'use strict';

vaccinesService.$inject = ["api", "config", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.vaccinesService = vaccinesService;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function vaccinesService(api, config, gettextCatalog) {
    var fluVaccinesEndDate = config.fluVaccines.startDate;
    var fluVaccinesStartDate = config.fluVaccines.endDate;

    return {
        setVaccinReservation: setVaccinReservation,
        getVaccines: getVaccines,
        vaccinsCanOrder: vaccinsCanOrder,
        canOrderVaccin: canOrderVaccin,
        allReservationsMade: allReservationsMade
    };

    function getVaccines() {
        return api.vaccinreservation.get({}).$promise.then(function (resource) {

            var vaccins = [{
                productNumber: '4297123',
                product: gettextCatalog.getString('VAXIGRIP TETRA 2021-2022 0,5 ML 1 WWSP'),
                // price: 8.07,
                amount: 224,
                // discountType: 'percentage',
                // discounts: [{
                //         amount: 112,
                //         percentage: 5
                //     },
                //     {
                //         amount: 224,
                //         percentage: 10
                //     }
                // ],
                disabled: false
            }, {
                productNumber: '4299764',
                product: gettextCatalog.getString('ALPHARIX TETRA 2021-2022 0,5 ML 1 WWSP'),
                // price: 8.07,
                amount: 180,
                // discountType: 'none',
                // discounts: [],
                disabled: false
            }, {
                productNumber: '4307617',
                product: gettextCatalog.getString('INFLUVAC S 2021-2022 0,5 ML 1 WWSP'),
                // price: 8.07,
                amount: 120,
                // discountType: 'none',
                // discounts: [],
                disabled: false
            }];

            vaccins.map(function (vaccin) {
                var vaccinSearch = resource.reservations.find(function (x) {
                    return vaccin.productNumber === x.productNumber;
                });
                vaccin.amount = !!vaccinSearch ? vaccinSearch.amount : 0;
                return vaccin;
            });
            vaccins.influvacReadOnly = resource.influvacReadOnly;
            return vaccins;
        });
    }

    function vaccinsCanOrder() {
        return (0, _moment2.default)(fluVaccinesStartDate).format('YYYY-MM-DD') >= (0, _moment2.default)().format('YYYY-MM-DD') && (0, _moment2.default)(fluVaccinesEndDate).format('YYYY-MM-DD') <= (0, _moment2.default)().format('YYYY-MM-DD');

        // let vaccin = vaccins.find((vaccin) => {
        //     return vaccin.amount > 0;
        // });
        // return vaccin === undefined ? false : true;
    }

    function allReservationsMade(vaccins) {
        return vaccins.every(amountNotZero);
    }

    function amountNotZero(vaccin) {
        return vaccin.amount !== 0;
    }

    function canOrderVaccin() {
        return (0, _moment2.default)(fluVaccinesStartDate).format('YYYY-MM-DD') >= (0, _moment2.default)().format('YYYY-MM-DD') && (0, _moment2.default)(fluVaccinesEndDate).format('YYYY-MM-DD') <= (0, _moment2.default)().format('YYYY-MM-DD'); // return vaccin.amount === 0;
    }

    function setVaccinReservation(vaccines) {
        var vaccinesPost = [];
        vaccines.forEach(function (vaccine) {
            vaccinesPost.push({
                productNumber: vaccine.productNumber,
                amount: vaccine.amount
            });
        });

        return api.setReservationAmounts.set({
            reservations: vaccinesPost
        }).$promise.then(function (resources) {
            return resources;
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/vaccinesService.js
// module id = 834
// module chunks = 0